module.exports = __webpack_public_path__ + "static/img/product-t20.75878f84.png";